import React, { useEffect, useState } from 'react';
import '../../styles.css';
import 'flatpickr/dist/flatpickr.min.css';
import Sidebar from '../Sidebar';
import { Session } from "../utils/session";
import MembersTable from './MembersTable';
import { useNavigate } from 'react-router-dom';

export default function MembersContent() {
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [hideDesktop, setHideDesktop] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const role = Session.getRole();
  const isTeamLeader = role === "Team Leader";

  const toggleSidebar = () => {
    if (window.innerWidth <= 991) {
      setShowMobileSidebar((s) => !s);
    } else {
      setHideDesktop((s) => !s);
    }
  };

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 991) {
        setShowMobileSidebar(false);
      }
    };

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Sidebar logic - useEffect for direct DOM manipulation
  useEffect(() => {
    const overlay = document.getElementById('sidebar-overlay');
    if (overlay) {
      overlay.style.display = showMobileSidebar ? 'block' : 'none';
    }
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      if (showMobileSidebar) sidebar.classList.add('show-mobile'); else sidebar.classList.remove('show-mobile');
      if (hideDesktop) sidebar.classList.add('hide-desktop'); else sidebar.classList.remove('hide-desktop');
    }
    const content = document.getElementById('content');
    if (content) {
      if (hideDesktop) content.classList.add('full-width'); else content.classList.remove('full-width');
    }
  }, [showMobileSidebar, hideDesktop]);

  return (
    <div>
      {/* Overlay for mobile sidebar - always rendered, visibility controlled by useEffect */}
      <div id="sidebar-overlay" className="sidebar-overlay" onClick={() => setShowMobileSidebar(false)} />
      
        <Sidebar />
      <div id="content">
    <div className='d-flex align-items-center' style={{ marginTop: 7, marginBottom: 32 }}>
    <div className="d-flex align-items-center mb-0 ">
          <button type="button" id="sidebarCollapse" className="btn btn-toggle me-3" onClick={toggleSidebar}>
            <i className="fas fa-bars" />
          </button>

        </div>
        <div className="d-flex justify-content-between align-items-center mb-0 page-header flex-wrap gap-2">
          <h2 className='tasks-title'>Members</h2>
        </div>
    </div>
        <div className="main-card">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2" style={{ marginRight: 70 }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by username, name, email, phone or role"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ maxWidth: 360 }}
            />
            {!isTeamLeader && (
              <button
                type="button"
                style={{ backgroundColor: '#0084fe', color: 'white', padding: '5px 12px', border: 'none', borderRadius: '11px' }}
                onClick={() => navigate('/Members/Create')}
              >
                +
              </button>
            )}
          </div>
          <div className="main-card">
            <MembersTable searchQuery={searchQuery} />
          </div>
        </div>
      </div>
    </div>
  );
}
